import { api } from './configs';
import { SERVER_URL } from '../constants';

class Api {
  static url = SERVER_URL;

  /* Site Start */

  static initSite({ lang }) {
    return api.get(`/init?lang=${lang}`);
  }

  /* Site End */

  /* Account Start */

  static auth(body) {
    return api.post('/account/auth', body);
  }

  static register(body) {
    return api.post('/account/profile', body);
  }

  static passwordRecovery({ email }) {
    return api.get(`/account/password/restore/${email}`);
  }

  static generateTokenForNewPassword({ code }) {
    return api.get(`/account/password/set/${code}`);
  }

  static setNewPassword(body) {
    return api.post('/account/profile/set_password', body);
  }

  static getProfile() {
    return api.get('/account/profile');
  }

  static saveProfile(body) {
    return api.patch('/account/profile', body);
  }

  static saveTutorialStage(body) {
    return api.post('/account/profile/set_tutorial_stage', body);
  }

  static sendFeedback(body) {
    return api.post('/feedback', body);
  }

  static init({ lang }) {
    return api.get(`/account/init?lang=${lang}`);
  }

  /* Account End */

  /* Data Start */

  static getALlCities(body) {
    return api.get('/account/cities', body);
  }

  /* Data End */

  /* Configurations Start */

  static calculateConfiguration(body) {
    return api.post('/account/calculate', body);
  }

  static createConfigurationWithScratch(body) {
    return api.post('/account/scratch', body);
  }

  static createConfigurationWithTemplate(params) {
    return api.get('/account/template', { params });
  }

  static getConfigurations(params) {
    return api.get('/account/configurations', { params });
  }

  static getSingleConfiguration({ id }) {
    return api.get(`/account/configurations/${id}`);
  }

  static editConfiguration(body) {
    return api.post('/account/configurations', body);
  }

  static detachConfigurations({ id, ...payload }) {
    return api.post(`/account/projects/${id}/detach`, payload);
  }

  static deleteConfigurations(body) {
    return api.post('/account/configurations/delete', body);
  }

  static generateConfigurationsEmail(body) {
    return api.post('/account/projects/email', body);
  }

  /* Configurations End */

  /* Projects Start */

  static getProjects(params) {
    return api.get('/account/projects', { params });
  }

  static createProject(body) {
    return api.post('/account/projects', body);
  }

  static updateProject({ body, id }) {
    return api.patch(`/account/projects/${id}`, body);
  }

  // Copies history configurations into the given projects. Does not remove configurations already there.
  static attachConfigurationsToProjects(body) {
    return api.post('/account/projects/attach', body);
  }

  static deleteProjects(body) {
    return api.post('/account/projects/delete', body);
  }

  static getConfigurationsOfProject({ id, params }) {
    return api.get(`/account/projects/${id}`, { params });
  }

  /* Projects End */

  /* Files Start */

  static generateConfigurationsPdf(body) {
    return api.post('/account/files/configurations/pdf', body, {
      responseType: 'blob',
    });
  }

  static generateConfigurationsArchive(body) {
    return api.post('/account/files/configurations/pdf/archive', body, {
      responseType: 'blob',
    });
  }

  static generateConfigurationsDocx(body) {
    return api.post('/account/files/configurations/docx', body, {
      responseType: 'blob',
    });
  }

  static generateProjectsPdf(body) {
    return api.post('/account/files/project/pdf', body, {
      responseType: 'blob',
    });
  }

  static generateProjectsArchive(body) {
    return api.post('/account/files/project/pdf/archive', body, {
      responseType: 'blob',
    });
  }

  static generateProjectsDocx(body) {
    return api.post('/account/files/project/docx', body, {
      responseType: 'blob',
    });
  }

  /* Files End */
}

export default Api;
